/* SHAPPY strona glowna: pas Futon (sections/shb-futon-home.liquid, 20.10.2026).
   Film: adres w data-src, preload="none". Laduje sie dopiero, gdy pas wejdzie na ekran (IntersectionObserver) albo po dotknieciu.
   Bez autostartu przy prefers-reduced-motion i oszczedzaniu danych (wtedy tylko po dotknieciu). Poza ekranem pauza. */
(function(){
  function init(m){
    if(m.__shbf) return; m.__shbf=1;
    var v=m.querySelector('video'), b=m.querySelector('[data-shbf-btn]'), img=m.querySelector('img');
    if(!v||!b) return;
    var src=v.getAttribute('data-src'), t0=parseFloat(v.getAttribute('data-t0')||'0')||0;
    var loaded=false, ready=!t0, stop=false, vis=false;
    var c=navigator.connection, rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto=!(c&&c.saveData)&&!rm;
    function ui(on){ m.classList.toggle('is-play',on); b.setAttribute('aria-label',b.getAttribute(on?'data-pause':'data-play')); }
    function show(){ if(ready&&!v.paused) m.classList.add('is-on'); }
    function load(){
      if(loaded) return; loaded=true;
      if(img&&img.currentSrc) v.setAttribute('poster',img.currentSrc);
      v.src=src; v.load();
    }
    function play(){ load(); var p=v.play(); if(p&&p.catch) p.catch(function(){ ui(false); }); }
    v.addEventListener('loadedmetadata',function(){ if(t0&&!ready){ try{ v.currentTime=t0; }catch(e){ ready=true; } } });
    v.addEventListener('seeked',function(){ if(!ready){ ready=true; show(); } });
    v.addEventListener('playing',function(){ ui(true); show(); });
    v.addEventListener('pause',function(){ ui(false); });
    function toggle(e){ if(e) e.preventDefault(); if(v.paused){ stop=false; play(); } else { stop=true; v.pause(); } }
    b.addEventListener('click',function(e){ e.stopPropagation(); toggle(e); });
    m.addEventListener('click',toggle);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){
        vis=e.isIntersecting;
        if(vis){ if(auto&&!stop) play(); } else if(!v.paused){ v.pause(); }
      }); },{rootMargin:'0px 0px -15% 0px',threshold:0.25}).observe(m);
    }
    document.addEventListener('visibilitychange',function(){ if(document.hidden&&!v.paused) v.pause(); else if(!document.hidden&&vis&&auto&&!stop&&loaded) play(); });
  }
  function all(){ var n=document.querySelectorAll('[data-shbf]'); for(var i=0;i<n.length;i++) init(n[i]); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
